const menu_data = [

  {
    id: 1,
    title: 'Contact',
    link: '/contact',
  },
]

export default menu_data;
